/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import messages from '@/locale';
import cn from '../../static/lang/cn.json';
Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'cn',
  fallbackLocale: 'cn',
  messages: {
    cn: {...zhLocale, ...cn},
    // en: {...enLocale, ...en}
  },
  silentTranslationWarn: true,
});
ElementLocale.i18n((key, value) => i18n.t(key, value))

// export default {
//   i18n,
// };



// WEBPACK FOOTER //
// ./src/until/vue-i18n.js